import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"
import Trix from "trix"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.initializeTribute()
  }

  disconnect() {
    this.tribute?.detach(this.fieldTarget)
    this.fieldTarget.removeEventListener("tribute-replaced", this.boundReplaced)
  }

  // Trix registers <trix-editor> from a setTimeout, so on a full page load the
  // element is still un-upgraded when Stimulus connects us and has no `editor`
  // yet. Read it lazily instead of caching it in connect().
  get editor() {
    return this.fieldTarget.editor
  }

  initializeTribute() {
    this.tribute = new Tribute({
      collection: [
        {
          allowSpaces: true,
          lookup: "display_name",
          values: this.fetchEmployees,
          trigger: "@",
          menuItemLimit: 5,
        },
        {
          allowSpaces: true,
          lookup: "id_with_name",
          values: this.fetchTasks,
          trigger: "#",
          menuItemLimit: 5,
        },
      ],
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.boundReplaced = this.replaced.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", this.boundReplaced)
  }

  fetchEmployees(text, callback) {
    fetch(`/mentions/employees.json?query=${text}`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        return response.json()
      })
      .then((employees) => callback(employees))
      .catch((_error) => callback([]))
  }

  fetchTasks(text, callback) {
    fetch(`/mentions/tasks.json?query=${text}`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        return response.json()
      })
      .then((employees) => callback(employees))
      .catch((_error) => callback([]))
  }

  replaced(e) {
    if (!this.editor) return

    const mention = e.detail.item.original
    const attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content,
    })
    this.editor.insertAttachment(attachment)
    this.editor.insertString(" ")
  }

  _pasteHtml(html, startPos, endPos) {
    if (!this.editor) return

    const position = this.editor.getPosition()
    this.editor.setSelectedRange([position - endPos, position])
    this.editor.deleteInDirection("backward")
  }
}
